import { TASKS_JSON } from "./tasks";
import { UI_EVENTS_JSON } from "./ui-events";
import { TEMPLATES_JSON } from "./templates";
import { BehaviorSubject } from "rxjs";
import { tap, map } from "rxjs/operators";
import { Map, List, fromJS } from "immutable";

var Data = (function() {
  function SingletonClass() {
    this.doStuff = () => {
      console.log("Hello " + specs);
    };
    this.addSpecs = specs => {
      //IDs ARE ADDED IN DATA.WALKING THROUGH TREE(PRE) AND SAVING INDIVIDUALLY
    };
    this.addUiComp = (name, parentId) => {
      var newId = Math.floor(Math.random() * 10000);
      var newSpec = {
        id: newId,
        type: "view",
        name: name,
        parent: parentId
      };
      console.log("Adding UI: " + JSON.stringify(newSpec));
      var currSpecs = specs.getValue();
      currSpecs.set(newId, newSpec);
      specs.next(currSpecs);
    };
    this.addComp = comp => {
      console.log("Adding COMP1: " + comp);
      var newId = Math.floor(Math.random() * 10000);
      var newSpec = comp.set("id", newId);
      console.log("Adding COMP: " + JSON.stringify(newSpec));
      let newSpecs = specs.getValue().set(newId, newSpec);
      specs.next(newSpecs);
      return newId;
    };
    this.changeSpec = spec => {
      console.log("changeSpec " + spec);
      let newSpecs = specs.getValue().set(spec.get("id"), spec);
      console.log(
        "changeSpec " +
          specs
            .getValue()
            .get(spec.get("id"))
            .get("name") +
          "  VS  " +
          newSpecs.get(spec.get("id")).get("name")
      );
      console.log(
        "changeSpec " +
          specs.getValue().get(spec.get("id")) +
          "  VS  " +
          newSpecs.get(spec.get("id"))
      );
      specs.next(newSpecs);
    };
    this.removeSpec = compId => {
      var currSpecs = specs.getValue();
      let newSpecs = currSpecs;
      currSpecs
        .valueSeq()
        .filter(
          spec => spec.get("target") === compId || spec.get("parent") === compId
        )
        .forEach(spec => (newSpecs = newSpecs.delete(spec.get("id"))));
      newSpecs = newSpecs.delete(compId);
      specs.next(newSpecs);
    };
    this.addSpec = obj => {
      console.log("Adding spec " + JSON.stringify(obj));
      specs.set(obj.id, obj);
    };
    this.getSpecs = () => {
      return specs.pipe(
        tap(spcs =>
          console.log(
            "set new specs: " + JSON.stringify(spcs.toIndexedSeq().toArray())
          )
        )
      );
    };
    /*this.getTemplates = () => {
      return templates;
    };*/
    this.getCompTemplates = () => {
      return compTemplates;
    };
    this.getCompTemplatesMapping = () => {
      return compTemplatesMapping;
    };
    /*this.getTypes = () => {
      return types;
    };*/
  }
  var instance;
  var specs = new BehaviorSubject();
  //var templates = new BehaviorSubject();
  var compTemplates = new BehaviorSubject();
  var compTemplatesMapping = new BehaviorSubject();
  //var types = new BehaviorSubject();
  return {
    getInstance: function() {
      if (instance == null) {
        instance = new SingletonClass();
        console.log("about to parse");
        var specsFile = fromJS(JSON.parse(TASKS_JSON));
        console.log(
          "PARSED:  " + JSON.stringify(specsFile.sortBy(item => item.get("id")))
        );
        var specsMap = specsFile.reduce((acc, spec) => {
          return acc.set(spec.get("id"), spec);
        }, new Map());
        console.log("PARSEDMAP:  " + specsMap);
        /*var templatesMap = file.get("templates").reduce((acc, temp) => {
          return acc.set(temp.get("id"), temp);
        }, new Map());*/
        var fileTemplatesBasic = fromJS(JSON.parse(TEMPLATES_JSON));
        var templatesBasicMap = fileTemplatesBasic.reduce((acc, temp) => {
          return acc.set(temp.get("type"), temp);
        }, new Map());
        let templateMapping = new Map();
        var addToTempMap = function(tempRef, tempToAdd) {
          let type = tempRef.get("type");
          templateMapping = templateMapping.set(
            type,
            templateMapping.get(type)
              ? templateMapping.get(type).push(tempToAdd)
              : new List([tempToAdd])
          );
          if (tempRef.get("parentType"))
            addToTempMap(
              templatesBasicMap.get(tempRef.get("parentType")),
              tempToAdd
            );
        };
        templatesBasicMap.forEach(temp => {
          addToTempMap(temp, temp);
        });
        console.log("INDEX TEMP " + JSON.stringify(templateMapping));
        /*var uiEvents = fromJS(JSON.parse(UI_EVENTS_JSON));
        console.log("PARSEDXX uiEvents:  " + JSON.stringify(uiEvents));
        var typesMap = uiEvents.reduce((acc, ev) => {
          return acc.set(
            ev.get("id"),
            ev.set(
              "values",
              ev.get("values").reduce((acc, val) => {
                return acc.set(
                  val.get("id"),
                  val.set(
                    "params",
                    val.get("params").map(param => {
                      var paramParts = param.split(" ");
                      return new Map({
                        name: paramParts[1],
                        type: paramParts[0],
                        optional: paramParts[2] === "optional"
                      });
                    })
                  )
                );
              }, new Map())
            )
          );
        }, new Map());*/

        specs.next(specsMap);
        //templates.next(templatesMap);
        compTemplates.next(templatesBasicMap);
        compTemplatesMapping.next(templateMapping);
        //types.next(typesMap);
        //console.log("MAPPED_UI_EVENTS:  " + typesMap);

        // Hide the constructor so the returned object can't be new'd...
        instance.constructor = null;
      }
      return instance;
    }
  };
})();

export default Data;



// WEBPACK FOOTER //
// ./src/App.js